import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { UnknownTransaction } from "src/pages/Admin/UnkownTransactions/Type";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";

async function getUnknownDetailTransactionsRequest(id: string) {
	return await apiClient
		.get(API.QUERY.ADMIN.UNKOWN_DETAIL_TRANSACTIONS(id))
		.then((res) => res.data);
}

export function useGetUnknownDetailTransactions(id: string) {
	return useQuery<UnknownTransaction[], AxiosError>({
		queryKey: ["adminUnknownTransactions", id],
		queryFn: () => getUnknownDetailTransactionsRequest(id),
		gcTime: 1000 * 60 * 60 * 24
	});
}
